export default {
  IS_LISTENING_CHANGE: 'IS_LISTENING_CHANGE',
}
